import {Translate} from 'react-redux-i18n';
import PropTypes from 'prop-types';
import Skeleton from '@material-ui/lab/Skeleton';

function DossierStateView(props) {
  const renderStats = percentage => {
    let containerClass = 'warning';

    if (percentage === 0) {
      containerClass = 'error';
    }

    if (percentage >= 100) {
      containerClass = 'success';
    }

    return (
      <div className="simple-number-stats mb-5">
        <>
          <div className={`number ${containerClass}`}>{percentage}%</div>
          <div className="label"><Translate value="globalDashboard.quitusDescription"/></div>
        </>
      </div>
    );
  };

  const renderLoading = () => (
    <div className="flex-container column center w-100">
      <Skeleton
        variant="rect"
        height={62}
        width={41}
      />
      <div className="w-100">
        <Skeleton variant="text"/>
      </div>
    </div>
  );

  function renderContent() {
    if (props.error) {
      return <div><Translate value={props.error}/></div>;
    }

    if (props.loading) {
      return renderLoading();
    }

    return renderStats(props.percentage);
  }

  return (
    <div className="card mb-3">
      <div className="card-header">
        <div className="card-title"><Translate value="globalDashboard.quitus"/></div>
      </div>
      <div
        className="flex-container column center space-between"
        style={{height: 'calc(100% - 48px)'}}
      >
        {renderContent()}
      </div>
    </div>
  );
}

DossierStateView.propTypes = {
  percentage: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.string
};

export default DossierStateView;
